import {toCamelCase} from 'case-converter'
import {
  fetchErrorsHandler,
  fetchStart,
  fetchSuccessful,
  fetchSynchronizer,
  getFetchDate,
  filterByValues
} from '~/helpers/prices/_utils/prices'

export const state = () => ({
  services: [],
  servicesFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setServices(state, services) {
    state.services = services
  },
  setServicesFetchDate(state, value) {
    state.servicesFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchServices({commit, state}, options) {
    const fetchParams = {
      credentials: 'include',
      headers: {
        locale: this.$i18n.locale
      }
    }

    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('/api/servers/v2/service', {...options, ...fetchParams})
        .then(res => res.result)
        .then(res => toCamelCase(res))
        .then(prices => {
          commit('setServices', prices)
          commit('setServicesFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  }
}

export const getters = {
  getServicesFetchDate(state) {
    return state.servicesFetchDate
  },
  getAllServices(state) {
    return state.services
  },
  getColocationServices(state) {
    return filterByValues(
      state.services,
      [
        {
          key: 'isOrder',
          values: [true]
        },
        {
          key: 'model',
          values: ['colocation']
        }
      ]
    )
  },
  getAdditionalColocationServices(state) {
    return state.services.filter(price => (price.model === 'equipment'
      || price.model === 'network'
      || (price.model === 'software'
        && (price.tariffLine === '1C_prof'
          || price.tariffLine === '1C_corp')))
      && price.isOrder
      && !price.isPrimary)
  },
  getSoftwareServices(state) {
    return filterByValues(
      state.services,
      [
        {
          key: 'isPrimary',
          values: [false]
        },
        {
          key: 'isOrder',
          values: [true]
        },
        {
          key: 'model',
          values: ['software', 'network']
        }
      ]
    )
  },
  getMicrosoftServices(state) {
    return filterByValues(
      state.services,
      [
        {
          key: 'isOrder',
          values: [true]
        },
        {
          key: 'model',
          values: ['software']
        },
        {
          key: 'tariffLine',
          values: ['msRDS', 'msSql', 'msLicenses']
        }
      ]
    )
  }
}